import type { Editor, Range } from "@tiptap/core";
import type { SceneBlockType } from "./types";
import { buildDefaultOutlineCards } from "./outlineCards";
import { buildDefaultNumberedSteps } from "./numberedSteps";
import { buildDefaultImageGrid } from "./imageGrid";

export function buildBlockContent(type: SceneBlockType, language: string) {
    switch (type) {
        case "outlineCards":
            return buildDefaultOutlineCards(3, language);
        case "numberedSteps":
            return buildDefaultNumberedSteps(3, language);
        case "imageGrid":
            return buildDefaultImageGrid(3, language);
    }
}

/** Replace the given range (or current selection) with a default block of the chosen type and focus it. */
export function insertBlock(
    editor: Editor,
    type: SceneBlockType,
    language: string,
    range?: Range
) {
    const content = buildBlockContent(type, language);
    const chain = editor.chain().focus();
    if (range) {
        chain.deleteRange(range);
    } else {
        // If the cursor is in an empty paragraph, eat it — otherwise insertContent
        // leaves the empty <p> sitting above the freshly inserted block.
        const { $from } = editor.state.selection;
        const parent = $from.parent;
        if (parent.type.name === "paragraph" && parent.content.size === 0) {
            chain.deleteRange({
                from: $from.before(),
                to: $from.after(),
            });
        }
    }
    chain.insertContent(content).run();
}
